import { internalFetch } from '../utils/fetchHelper';
import { IPagedCollection } from '@moko/utils';

export interface IIssue {
  id: number;
  comment: string;
  imageUrl: string;
  images: string[];
  imagesUrls: string[];
  imagesCaption: string[];
  worksCount: number;
  createdAt: string;
  otherInfo: string;
  zoneId: number;
  zoneAssetCat?: number;
  assetId: number;
  issueTypeId?: number;
  uuid: string;
  steps: string;
}

export interface imageAnalysis {
  caption: string;
}

export interface IIssueImage {
  imageContent: string;
  caption: string;
}

export interface IUpdateIssueRequest {
  assetId: number | undefined;
  zoneId?: number;
  issueTypeId?: number;
  comment?: string;
  otherInfo?: string;
}

export interface IIsueType {
  id?: number;
  code: string;
  name: string;
  priority?: string;
}

export const getIssue = async (
  abortController: AbortController,
  issueId: number
): Promise<IIssue> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/i/issue?issueId=${issueId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getIssues = async (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  search?: string,
  filters?: string
): Promise<IPagedCollection<IIssue>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/i/issues?pageSize=${pageSize}&pageNo=${pageNo}${
      search ? `&search=${search}` : ''
    }${filters ? `&filters=${filters}` : ''}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const analyseIssueImage = async (
  abortController: AbortController,
  issueId: number,
  imageUrl: string
): Promise<imageAnalysis> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/i/analyseIssueImage?issueId=${issueId}&issueImageUrl=${imageUrl}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const editIssue = async (
  abortController: AbortController,
  issueId: number,
  issue: IUpdateIssueRequest
): Promise<number> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/i/issueById?issueId=${issueId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(issue)
  );
};

export const getIssueImage = async (
  abortController: AbortController,
  imageUrl: string,
  container?: string
): Promise<IIssueImage> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/i/issueImage?imageUrl=${imageUrl}${
      container ? `&container=${container}` : ''
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};

export const getAssetIssueTypes = async (
  abortController: AbortController,
  assetId: number
): Promise<IIsueType[]> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/assetIssueTypes?assetId=${assetId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};
